import { PolicyLayout } from "@/components/PolicyLayout";

export default function Terms() {
  return (
    <PolicyLayout title="Terms & Conditions" updated="June 2026" testId="page-terms">
      <p>
        These Terms &amp; Conditions ("Terms") govern your access to and use of the crazyOne app store website, its
        content, subscriptions, and related services (collectively, the "Service"). By using the Service or purchasing a
        subscription, you agree to be bound by these Terms.
      </p>

      <h2>1. The Service</h2>
      <p>
        crazyOne is a digital platform that lists Android applications (APK files) for download and offers optional paid
        subscription plans. Some features and content may be provided to third-party Android applications that integrate
        with crazyOne. All pricing on this website is displayed in Indian Rupees (INR ₹).
      </p>

      <h2>2. Accounts &amp; access</h2>
      <ul>
        <li>Browsing and downloading listed apps is available to all visitors.</li>
        <li>Administrative access is restricted to authorised personnel only.</li>
        <li>You are responsible for maintaining the confidentiality of any credentials issued to you.</li>
      </ul>

      <h2>3. Subscriptions &amp; payments</h2>
      <ul>
        <li>Subscription plans, their prices (in INR ₹), and validity periods are shown on the Pricing page.</li>
        <li>Payments are collected securely via Cashfree Payments. crazyOne does not store your card or bank details.</li>
        <li>Discount coupon codes, where offered, are applied at the time of purchase and are subject to availability.</li>
        <li>A subscription becomes active only after the payment is successfully verified.</li>
      </ul>

      <h2>4. Software &amp; downloads</h2>
      <p>
        APK files are provided "as is". While we take reasonable measures to verify uploaded software, you are responsible
        for reviewing app permissions before installation on your device. Installing applications from outside the Google
        Play Store may require enabling "unknown sources" on your Android device.
      </p>

      <h2>5. Acceptable use</h2>
      <ul>
        <li>Do not misuse, reverse-engineer, or attempt to gain unauthorised access to the Service.</li>
        <li>Do not use the Service for any unlawful purpose or to distribute malicious software.</li>
      </ul>

      <h2>6. Intellectual property</h2>
      <p>
        All trademarks, logos, and content on the Service are the property of crazyOne or their respective owners and may
        not be used without prior written permission.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, crazyOne shall not be liable for any indirect, incidental, or consequential
        damages arising from your use of the Service or any third-party software obtained through it.
      </p>

      <h2>8. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the Service after any change constitutes acceptance
        of the revised Terms.
      </p>

      <h2>9. Contact</h2>
      <p>
        For any questions about these Terms, contact us at <a href="mailto:support@crazyone.app">support@crazyone.app</a>.
      </p>
    </PolicyLayout>
  );
}
